import { $, on } from "@olmokit/dom";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import FormsBase from "@olmokit/core/forms/base";
import { globalConf } from "@olmokit/core/data";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/textarea/filled";
import "./index.scss";

/**
 * Component: FormProfessional
 *
 */
export function FormProfessional() {

  const form1 = $('[data-fragment-id="professionalForm"]');
  const form2 = $('[data-fragment-id="professional2Form"]');

  const step1 = $('.Contacts:navStep.Contacts:navStep01 span');

  const $root = $(".Contacts:");

  FormsBase($root, ".Contacts:professional_form", {
    url: globalConf.baseUrl + "/_/forms/olmoforms/send/2/",
    succeded: handleSucceded,
    failed: handleFailed,
  });  

  FormsInputMaterial();
  FormsSelectMaterial();

  /**
   * Handle succeeded
   *
   * @param {object} formData The data sent to the server
   * @param {object} instance The form instance
   * @param {object} response The server response
   */
  function handleSucceded(formData, instance, response) {

    form1.style.display = 'none';
    form2.style.display = 'block';

    $('#step').innerHTML = '02';

    dataLayer.push({
      ...formData,
      event: "form sent",
      form: "Form Professional",
    }); 
  }

  /**
   * Handle failed
   *
   * @param {object} formData The data sent to the server
   * @param {object} instance The form instance
   * @param {object} response The server response
   */
  function handleFailed(formData, instance, response) {
    console.error('response');
  }    

  // on(step1, 'click', () => {
  //   form1.style.display = 'block';
  //   form2.style.display = 'none';
  // });
  
  return {
    destroy() {
      // olmoform.destroy();
    },
  };

}
